import React from 'react';
import {
  CardMedia,
  Card,
  CardTitle,
  CardActions,
  Button
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import QuotesHeader from '../QuotesHeader';
import { nullStatePropTypes } from './nullStatePropTypes';

const DesktopNullView = ({
  cardTitle,
  cardBody,
  learnMoreText,
  imageUrl,
  imageAlt,
  componentId
}) => {

  const { ref, clickID } = useImpression({
    data: {
      component: 'QuotesFallbackView',
      name: 'QuotesFallbackView',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="Quotes"
      data-testid="quotes-container"
      className="sui-h-full"
      orientation="horizontal"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
      ref={ref}
      clickid={clickID}
    >
      {/* eslint-disable-next-line react/no-unknown-property */}
      <div className="sui-flex sui-gap-4 sui-h-full">
        <div
          className={classNames(
            'sui-flex',
            'sui-flex-col',
            'sui-gap-4',
            'sui-h-full',
            'sui-min-w-64'
          )}
        >
          <div className="sui-mb-4">
            <QuotesHeader hideActionLink />
          </div>
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={cardTitle}
          />
          {cardBody}
          <CardActions>
            <Button variant="secondary" href="/c/create-a-quote">
              {learnMoreText}
            </Button>
          </CardActions>
        </div>
        <div>
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className={classNames(
              'sui-w-full',
              'sui-h-full',
              'sui-transform',
              'sui-object-cover',
              'sui-object-center'
            )}
          />
        </div>
      </div>
    </Card>
  );
};

DesktopNullView.propTypes = nullStatePropTypes;

export default DesktopNullView;
